module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/mobile/home-71eed6103939f43facfca59a41f0d27c.jpg";